export default "__VITE_ASSET__C$q0Q5cE__"